import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Cube03 = function Cube03(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M3 8.6627c0-.2445 0-.3668.0276-.482a1 1 0 0 1 .1198-.289c.0618-.1009.1483-.1874.3212-.3603l4.0628-4.0628c.173-.173.2594-.2594.3603-.3212a1 1 0 0 1 .289-.1198C8.296 3 8.4183 3 8.6628 3H20.2c.28 0 .42 0 .527.0545a.4996.4996 0 0 1 .2185.2185C21 3.38 21 3.52 21 3.8v11.5373c0 .2445 0 .3668-.0276.4819a.9981.9981 0 0 1-.1198.2891c-.0618.1009-.1483.1874-.3212.3603l-4.0628 4.0628c-.1729.1729-.2594.2594-.3603.3212a.9981.9981 0 0 1-.2891.1198C15.7041 21 15.5818 21 15.3373 21H3.8c-.28 0-.42 0-.527-.0545a.4996.4996 0 0 1-.2185-.2185C3 20.62 3 20.48 3 20.2V8.6627Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3.5 8H16m0 0v12.5M16 8l4.5-4.5m.5 11.8373V3.8c0-.28 0-.42-.0545-.527a.4996.4996 0 0 0-.2185-.2185C20.62 3 20.48 3 20.2 3H8.6627c-.2445 0-.3668 0-.482.0276a1 1 0 0 0-.289.1198c-.1009.0618-.1874.1483-.3603.3212L3.4686 7.5314c-.173.173-.2594.2594-.3212.3603a1 1 0 0 0-.1198.289C3 8.296 3 8.4183 3 8.6628V20.2c0 .28 0 .42.0545.527a.4996.4996 0 0 0 .2185.2185C3.38 21 3.52 21 3.8 21h11.5373c.2445 0 .3668 0 .4819-.0276a.9981.9981 0 0 0 .2891-.1198c.1009-.0618.1874-.1483.3603-.3212l4.0628-4.0628c.1729-.1729.2594-.2594.3212-.3603a.9981.9981 0 0 0 .1198-.2891C21 15.7041 21 15.5818 21 15.3373Z"
    })]
  }));
};
export default Cube03;